import angular from 'angular';

module.exports = angular.module('market.routes.postcard-terms', [
  require('angular-ui-router'),
])
.config(function($stateProvider) {
  $stateProvider.state('postcard-terms', {
    parent: 'root',
    url: '/postcardterms',
    templateUrl: '/templates/market/postcard-terms.html',
    data: {
      meta: {
        titleSuffix: " | Postcard terms of use",
      }
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/postcard-terms.js
 **/